import { createFileRoute, redirect } from '@tanstack/react-router';

import { isAuthenticated, isExpired, clearTokens } from '~/lib/auth';

/**
 * Smart redirect entry point for /$slug.
 * Routes to auth (unauthenticated) or episodes/game based on landing page type.
 */
export const Route = createFileRoute('/$slug/')({
  beforeLoad: ({ context }: { context: Record<string, any> }) => {
    const slug = context.slug as string;
    const landingPage = context.landingPage as {
      targetType: 'show' | 'episode';
      targetId: string;
    };

    if (isExpired()) clearTokens();

    if (!isAuthenticated()) {
      throw redirect({ to: '/$slug/auth', params: { slug } });
    }

    if (landingPage.targetType === 'show') {
      throw redirect({ to: '/$slug/episodes', params: { slug } });
    } else {
      throw redirect({
        to: '/$slug/game/$episodeId',
        params: { slug, episodeId: landingPage.targetId },
      });
    }
  },
});
